import { MaterialGradeSchema } from "./PrismaZod";

export const MaterialGrade = MaterialGradeSchema.enum;
